import { Text, VStack } from '@chakra-ui/react';

import type { TContentCreatorApplicationSummary } from '@/services/api/requests/contentCreatorApplications';
import ApplicantApplicationInfoCard from './ApplicantApplicationInfoCard';

const ApprovedApplicationDetails = ({ application }: { application: TContentCreatorApplicationSummary }) => {
  return (
    <VStack minHeight={'100vh'} width={'100vw'} paddingX={'24px'} paddingY={'120px'} spacing={'24px'}>
      <VStack spacing={'10px'} maxWidth={'620px'}>
        <Text
          variant={'loraTitle'}
          color={'white'}
          fontSize={'26px'}
          lineHeight={'32px'}
          fontWeight={'400'}
          textAlign={'center'}
        >
          Application Approved
        </Text>
        <Text
          color={'white'}
          fontSize={'16px'}
          fontWeight={'500'}
          lineHeight={'22px'}
          textAlign={'center'}
          opacity={0.85}
        >
          Your content creator application was reviewed and approved. Please check your email to set your password and
          login.
        </Text>

        <Text
          color={'white'}
          fontSize={'16px'}
          fontWeight={'500'}
          lineHeight={'22px'}
          textAlign={'center'}
          opacity={0.85}
        >
          You can find your application details below.
        </Text>
      </VStack>

      <ApplicantApplicationInfoCard
        application={application}
        dateLabel={'DECISION DATE'}
        dateValue={application.decidedAt}
      />
    </VStack>
  );
};

export default ApprovedApplicationDetails;
